import React, { useMemo, Fragment, useState, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate, useOutletContext } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import {
  useGetAccountAdminListQuery,
  useGetDownloadRefFileQuery,
  useUpdateRefReqMutation,
} from "../../../../../reactQueries/AppApi/rqHooksForReferrals";
import {
  useGetServiceOfficeListMutation,
  useTrackActivityMutation,
} from "../../../../../reactQueries/commonRQHooks";
import { saveAs } from "file-saver";
import { useContext } from "react";
import { Context } from "../../../../../../common/context/Context";
import { assignReferralViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import MuiLink from "@mui/material/Link";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
//import { useOutletContext } from "react-router-dom";

const EditAssignReferralReq = ({ referralById }) => {
  let navigate = useNavigate();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const {
    clientPortalAdminRoleId,
    isEnterpriseAdmin,
    id: userId,
    firstName,
    lastName,
  } = loggedInUser;

  const userName = `${firstName} ${lastName}`;
  const docStatus = referralById.DocumentStatus?.toLowerCase();
  const isDisabled =
    docStatus === "incomplete-deleted".toLowerCase() ||
    docStatus === "completed-deleted".toLowerCase();
  const isRejected =
  referralById?.DocumentStatus === "Rejected";

  const schema = yup.object().shape({
    assigned_to: yup
      .object()
      .label("This field")
      .required()
      .typeError("This field is a required"),
  });

  // api - update ref request mutation
  const {
    mutate: updateRefReq,
    isError: isErrorOnUpdate,
    isLoading: isLoadingOnUpdate,
    isSuccess: isSuccessOnUpdate,
    data: dataOnUpdate,
    error: errorOnUpdate,
  } = useUpdateRefReqMutation();

  const defaultValues = {
    // ref_docfile: referralById?.ref_docfile,
    ref_docname: referralById?.DocumentName || "",
    submitted_by: `${referralById?.CreatedBy}, ${referralById.EmailAddress}`,
    submitted_on: referralById?.SubmittedOn,
    client_account: referralById?.ClientAccountName || "",
    client_sub_account: referralById?.ClientSubAccountName || "",
    service_office: referralById?.service_office || "",
    // NEW FIELD
    rejection_reason: "",
  };

  const rhfFormInstance = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { watch, setValue } = rhfFormInstance;

  const [id, setId] = useState("");
  const [brandId, setBrandId] = useState("");

  // api - get admin list dropdown data
  const {
    isSuccess: isSuccessOnAdminList,
    isFetching: isFetchingOnAdminList,
    error: errorOnAdminList,
    data: adminListData,
    isError: isErrorOnAdminList,
  } = useGetAccountAdminListQuery();

  // api - get service office list data
  const {
    mutate: getServiceOfficeList,
    isError: isErrorOnServiceOfficeList,
    isLoading: isLoadingOnServiceOfficeList,
    isSuccess: isSuccessOnServiceOfficeList,
    data: serviceOfficeListData,
    error: errorOnServiceOfficeList,
  } = useGetServiceOfficeListMutation();
useEffect(() => {
  if (referralById?.DocumentStatus === "Rejected") {
    setValue(
      "rejection_reason",
      referralById?.DocumentRejectionReason || "",
      {
        shouldValidate: true,
      }
    );
  }
}, [referralById, setValue]);
  useEffect(() => {
    getServiceOfficeList();
  }, []);

  useEffect(() => {
    if (
      !!serviceOfficeListData?.data &&
      !!serviceOfficeListData?.data?.length
    ) {
      let serviceOfficeList = [];
      referralById.rightOfficeKey.forEach((eachServiceOffice) => {
        const foundItem = serviceOfficeListData?.data.find((item) => {
          return item.rightOfficeKey === eachServiceOffice;
        });

        if (!!foundItem) {
          serviceOfficeList.push(foundItem.masterRightOfficeName);
        }
      });

      setValue("service_office", serviceOfficeList.toString() || "", {
        shouldValidate: true,
      });
    }
  }, [serviceOfficeListData?.data, referralById]);

  //
  const {
    isSuccess: isSuccessOnDownloadFile,
    isFetching: isFetchingOnDownloadFile,
    isLoading: isLoadingOnDownloadFile,
    error: errorOnDownloadFile,
    data: downloadFileData,
    isError: isErrorOnDownloadFile,
  } = useGetDownloadRefFileQuery({
    Id: id,
    BrandId: brandId,
  });

  const downloadFile = () => {
    setId(referralById?.Id);
    setBrandId(referralById.BrandId);
  };

  useEffect(() => {
    if (!!isSuccessOnDownloadFile) {
      saveAs(downloadFileData, `${referralById?.DocumentName}`);
      setId("");
      setBrandId("");
    }
    if (!!isErrorOnDownloadFile) {
      // console.log("isErrorOnDownloadFile called");
      setId("");
      setBrandId("");
    }
  }, [isSuccessOnDownloadFile, isErrorOnDownloadFile]);

  const assignToAutocompleteList =
    !!adminListData &&
    adminListData.map((item) => {
      return {
        id: item.adminId,
        selectOptionLabel: `${item.firstName}-${item.lastName} (${item.permissionRole})`,
        selectOptionValue: item.adminId,
        extraData: item,
      };
    });

  useEffect(() => {
    if (!!adminListData && !!adminListData?.length) {
      let selectedValue = {};

      const foundItem = adminListData?.find((item) => {
        return item.adminId === referralById.AdminId;
      });

      if (!!foundItem) {
        selectedValue = {
          id: foundItem.adminId,
          selectOptionLabel: `${foundItem.firstName}-${foundItem.lastName} (${foundItem.permissionRole})`,
          selectOptionValue: foundItem.adminId,
          extraData: foundItem,
        };
      }
      setValue("assigned_to", selectedValue || "", {
        shouldValidate: true,
      });
    }
  }, [adminListData, referralById]);

  /**form handling */
  const onSubmit = (data) => {
    const body = {
      Id: referralById?.Id,
      AdminId: data?.assigned_to?.id,
      AssignedTo: `${data?.assigned_to?.extraData.firstName}-${data?.assigned_to?.extraData.lastName}`,
      UpdatedFrom: userId,
      UpdatedBy: userName,
    };
    updateRefReq({ body });
  };

  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      navigate(assignReferralViewPath);
    }
  }, [isSuccessOnUpdate]);

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity();
  useEffect(() => {
    if (!!isSuccessOnDownloadFile) {
      trackActivity({
        activitySuccess: !!isSuccessOnDownloadFile,
        actionType: "Downloaded",
        itemId: referralById?.Id || "",
      });
    }
  }, [isSuccessOnDownloadFile]);

  const referralsCMSData = useOutletContext();

  const fetchAssignRefReqListLabel = (key) => {
    if (
      referralsCMSData &&
      referralsCMSData?.pageContent["AssignReferralRequestsList"]
    ) {
      const referralsCMSDataLabel =
        referralsCMSData.pageContent["AssignReferralRequestsList"];
      return returnLabel(referralsCMSDataLabel?.Labels, key);
    }
    return "";
  };

  const fetchAssignRefReqLabel = (key) => {
    if (
      referralsCMSData &&
      referralsCMSData?.pageContent["AssignReferralRequest"]
    ) {
      const referralsCMSDataLabel =
        referralsCMSData.pageContent["AssignReferralRequest"];
      return returnLabel(referralsCMSDataLabel?.Labels, key);
    }
  };

  const fetchCommonCMSLabel = (key) => {
    if (referralsCMSData && referralsCMSData?.pageContent["CommonComponent"]) {
      const commonCMSDataLabel =
        referralsCMSData.pageContent["CommonComponent"];
      return returnLabel(commonCMSDataLabel?.Labels, key);
    }
    return "";
  };

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
      return labelArray.find((x) => x.Key === key)?.Phrase || "";
    }
    return "";
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Assign Referral Request */}
        {fetchAssignRefReqLabel("AssignReferralRequest.AssignReferralRequest")}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={assignReferralViewPath}
        >
          {/* Referral Requests */}
          {fetchAssignRefReqLabel("AssignReferralRequest.ReferralRequests")}
        </Button>
      </Stack>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <MpgItem sx={{ padding: { xs: "20px" } }}>
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {/* Referral Details */}
                {fetchAssignRefReqLabel(
                  "AssignReferralRequest.ReferralDetails"
                )}
              </Typography>

              <div>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"ref_docname"}
                  label={fetchAssignRefReqLabel(
                    "AssignReferralRequest.ReferralFileName"
                  )} //{"Referral file name"}
                  multiline
                  rows={2}
                  fullWidth
                  disabled
                />

                <MuiLink
                  onClick={isDisabled ? undefined : () => downloadFile()}
                  sx={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    color: isDisabled ? "text.disabled" : "primary.main",
                    cursor: isDisabled ? "default" : "pointer",
                  }}
                >
                  {referralById?.DocumentName}
                </MuiLink>
              </div>

              <MpgAutocompleteSingle
                rhfFormInstance={rhfFormInstance}
                name={"assigned_to"}
                label={fetchAssignRefReqLabel("AssignReferralRequest.AssignTo")} //{"Assign To"}
                fullWidth
                optionList={assignToAutocompleteList || []}
                disabled={isDisabled} 
              />
              {isRejected && (
              <Box sx={{ mt: 2 }}>
                <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"rejection_reason"}
                label={"Rejection Reason"}
                multiline
                rows={5}
                fullWidth
                disabled
                />
              </Box>
              )}
            </MpgItem>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MpgItem>
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {/* Client User Information */}
                {fetchAssignRefReqLabel(
                  "AssignReferralRequest.ClientUserInformation"
                )}
              </Typography>
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"submitted_by"}
                label={fetchAssignRefReqLabel(
                  "AssignReferralRequest.SubmittedByClientUser"
                )} //{"Submitted By Client User"}
                fullWidth
                disabled
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"submitted_on"}
                label={fetchAssignRefReqListLabel(
                  "AssignReferralRequestsList.SubmittedOn"
                )} //{"Submitted On"}
                fullWidth
                disabled
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"client_account"}
                label={fetchAssignRefReqLabel(
                  "AssignReferralRequest.UserBelongsToClientAccount"
                )} //{"User belongs to Client Account"}
                fullWidth
                disabled
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"client_sub_account"}
                label={fetchAssignRefReqLabel(
                  "AssignReferralRequest.UserBelongsToClientSubAccountGroup"
                )} //{"User belongs to Client Sub-Account Group"}
                fullWidth
                disabled
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                label={fetchAssignRefReqLabel(
                  "AssignReferralRequest.UserBelongsToServiceOffice"
                )} //"User belongs to Service Office"}
                name={"service_office"}
                multiline
                rows={4}
                fullWidth
                disabled
              />
            </MpgItem>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            variant="outlined"
            size="small"
            type="submit"
            sx={{ marginTop: "15px" }}
            disabled={isDisabled} 
          >
            {fetchCommonCMSLabel("Common.Save") /* Save */}
          </Button>
        </Grid>
      </Box>

      {/** error dialog on update action */}
      <MpgErrorDialog open={!!isErrorOnUpdate || !!isErrorOnDownloadFile} />
      <MpgLoadingDialog open={!!isLoadingOnUpdate} />
    </Box>
  );
};

export default EditAssignReferralReq;
